
import Popup from 'vux/src/components/popup/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

export default {
components: {
Popup,
Loading
},
beforeCreate: function () {
document.body.className = 'charge'
},
data () {
return {
videoon: false,
videooff: true,
popvid: false
}
},
methods: {









closevid () {
var video = document.getElementById('videoinfo')
video.removeAttribute('src')
this.popvid = false
},
viewvideo (videoname) {
this.popvid = true
setTimeout(function () {
var video = document.getElementById('videoinfo')
video.setAttribute('type', 'video/mp4')
video.setAttribute('src', `static/images/helpcenter/${videoname}.mp4`)
video.load()
video.play()
}, 500)
}

}
}



// WEBPACK FOOTER //
// ./src/components/HelpCenter.vue